import { localStorageSupported } from '#lib/helper/browser.js';
import {
	apiAdminImpersonate,
	UserRole,
	type BusinessAdmin,
	type User
} from '#lib/types/generated/index.js';
import { get, writable } from 'svelte/store';
import { appDataLoaded, refreshAppData } from './app';
import { businessStore, createDefaultBusiness } from './business';
import { t } from './i18n';
import { toastSuccess } from './toast';
import { createDefaultUser, loadUser, userStore } from './user';

// Admin store creation
export const adminStore = writable<boolean>(false);
userStore.subscribe((user: User) => {
	if (user.role === UserRole.Super) {
		const stored = localStorage.getItem('admin');
		adminStore.set(stored !== 'false');
	} else {
		adminStore.set(false);
	}

	return () => {};
});

adminStore.subscribe((value) => {
	if (get(userStore).role === UserRole.Super && localStorageSupported()) {
		localStorage.setItem('admin', String(value));
	}

	return () => {};
});

export const RESERVATOO_BUSINESS_ID = 'c56356b3-0246-47bf-8f0f-638f372badb6';

export const adminCurrentBusiness = writable<BusinessAdmin | undefined>(undefined);

export function impersonate(businessOrId: BusinessAdmin | string | undefined): Promise<void> {
	if (!businessOrId) return Promise.resolve();

	appDataLoaded.set(false);
	businessStore.set(createDefaultBusiness());
	userStore.set(createDefaultUser());

	const payload =
		typeof businessOrId === 'string'
			? { business: businessOrId }
			: { user: businessOrId.owner.id };

	const toastName = typeof businessOrId === 'string' ? 'le business' : businessOrId.name;

	return apiAdminImpersonate(payload).then(() => {
		return loadUser().then(() => {
			refreshAppData(true);
			toastSuccess(get(t)('impersonate.connected', { name: toastName }), { icon: 'lock' });
		});
	});
}
